import React, { useMemo, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { Form } from 'formik-antd';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Box, FormInput, Button, CustomInput } from 'atoms';
import { updateVendor } from 'store/vendorSlice';
import { Debug } from '../Debug';
// import { useQuery } from 'hooks';
import { ACL, EditModeBtn } from 'components/common';
import { CancelButton, DatePickers } from 'utils/commonStyled';
import { DATE_FORMAT } from 'utils';

const FormSchema = () =>
	Yup.object({
		tax_cert_start_date: Yup.date().required().label('Start Date'),
		tax_cert_valid_till: Yup.date()
			.required()
			.label('Valid Till')
			.when(
				'tax_cert_start_date',
				(tax_cert_start_date, yup) =>
					tax_cert_start_date &&
					yup.min(tax_cert_start_date, 'End Date cannot be before Start Date')
			),
		cert_no: Yup.string()
			.min(4)
			.required()
			.max(32)
			.label('Certificate No.')
			.matches(
				/^[a-zA-Z0-9]*$/,
				'Certificate should be Alpha-numeric, . (dot) and - (hyphen) allowed'
			),
		// tds_section: Yup.string()
		// 	.min(1)
		// 	.max(5)
		// 	.label('TDS Section')
		// 	.matches(/^[a-zA-Z0-9]*$/, 'Certificate should be Alpha-numeric, - (hyphen) allowed'),
		// tds_rate: Yup.number().min(1).max(9999999).label('TDS Rate'),
		// amount_limit: Yup.number().min(1).max(9999999).label('TDS Rate'),
	});

export default function TaxDeductionForm({ isEditMode = false, formData = {}, otherFormsData }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [editMode, setEditMode] = useState(false);

	const initialValues = useMemo(
		() => ({
			cert_no: formData?.cert_no || undefined,
			// tds_section: formData?.tds_section || undefined,
			tax_cert_start_date: formData?.tax_cert_start_date || undefined,
			tax_cert_valid_till: formData?.tax_cert_valid_till || undefined,
			// tds_rate: formData?.tds_rate || undefined,
			// amount_limit: formData?.amount_limit || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const { tax_cert_start_date, tax_cert_valid_till, ...rest } = values;

		let payload;

		if (isEditMode) {
			payload = {
				update_type: 'vendor',
				...otherFormsData,
				tax_info: {
					...rest,
					tax_cert_start_date: moment(tax_cert_start_date).format(DATE_FORMAT),
					tax_cert_valid_till: moment(tax_cert_valid_till).format(DATE_FORMAT),
				},
			};
		}

		dispatch(updateVendor({ req_data: payload, setErrors, isEditMode }))
			.then((res) => {
				setSubmitting(false);
				window.location = `${window.origin}/vendors/${res.data.id}?tab=5`;
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleEdit() {
		setEditMode(!editMode);
	}

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{() => (
				<>
					{otherFormsData?.vendor_type === 'regular' && (
						<ACL action="update" module="vendor">
							{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
						</ACL>
					)}

					<Form className={editMode === false ? 'disabled-div' : ''}>
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="cert_no" label="Certificate No.">
										<CustomInput name="cert_no" />
									</FormInput>
								</Col>
								{/* <Col lg={12}>
									<FormInput name="tds_section" label="TDS Section">
										<CustomInput name="tds_section" />
									</FormInput>
								</Col> */}
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="tax_cert_start_date" label="Start date *">
										<DatePickers name="tax_cert_start_date" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="tax_cert_valid_till" label="Valid Till *">
										<DatePickers name="tax_cert_valid_till" />
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								{/* <Col lg={12}>
									<FormInput name="tds_rate" label="TDS Rate">
										<CustomInput name="tds_rate" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="amount_limit" label="Amount Limit">
										<CustomInput name="amount_limit" />
									</FormInput>
								</Col> */}
							</Row>
						</Box>

						{otherFormsData?.vendor_type === 'regular' && (
							<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
								<CancelButton
									onClick={() => navigate('/vendor-list')}
									type="button"
								>
									Cancel
								</CancelButton>
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									{isEditMode ? 'Update' : 'Submit'}
								</Button>
							</Box>
						)}
						<Debug />
					</Form>
				</>
			)}
		</Formik>
	);
}

TaxDeductionForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
